import { render, staticRenderFns } from "./fourthLogoRow.vue?vue&type=template&id=ded151c2&"
import script from "./fourthLogoRow.vue?vue&type=script&lang=js&"
export * from "./fourthLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports